/**
 * Common password checker powered by Mozilla's fxa-common-password-list.
 * Contains ~1 million commonly breached/used passwords.
 *
 * If you need to block additional passwords specific to your organisation,
 * add them to the `additionalBlockedPasswords` array below.
 */

const fxaPasswordList = require("fxa-common-password-list")

/**
 * Add any organisation-specific passwords to block here.
 * These are checked in addition to the ~1M passwords from Mozilla's list.
 */
const additionalBlockedPasswords: string[] = [
  "irishlife",
  "smartlife",
  "changeme",
]

/**
 * Returns true if the given password is a commonly used / breached password.
 */
export const isCommonPassword = (password: string): boolean => {
  const lower = password.toLowerCase()
  return (
    fxaPasswordList.test(lower) || additionalBlockedPasswords.includes(lower)
  )
}

export default isCommonPassword
